import React from "react";
import classes from "./ContactUs.module.css";
import ContactForm from "./ContactForm";
import ContactDetails from "./ContactDetails";
import { useTranslation } from "react-i18next";

function ContactUs() {
  const { t } = useTranslation();

  return (
    <div className={classes.contactDiv} id="contactSection">
      <h3>{t("Get in Touch.title")}</h3>
      <div className={classes.wrapper}>
        <div className={classes.gridItem1}>
          <ContactDetails />
        </div>
        <div className={classes.gridItem2}>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
